export const resolveMediaSource: () => typeof MediaSource = () =>
  window.MediaSource ||
  ((window as any).WebKitMediaSource as MediaSource) ||
  ((window as any).ManagedMediaSource as MediaSource);
export const resolveSourceBuffer: () => typeof SourceBuffer = () =>
  window.SourceBuffer || (window as any).WebKitSourceBuffer || (window as any).ManagedSourceBuffer;

export const isHLSSupported: () => boolean = () => {
  const mediaSource: typeof MediaSource = resolveMediaSource();

  if (!mediaSource) {
    return false;
  }

  const sourceBuffer: typeof SourceBuffer = resolveSourceBuffer();

  const isTypeSupported: boolean =
    typeof mediaSource.isTypeSupported === 'function' &&
    mediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"');

  const sourceBufferValidAPI: boolean =
    !sourceBuffer ||
    (sourceBuffer.prototype &&
      typeof sourceBuffer.prototype.appendBuffer === 'function' &&
      typeof sourceBuffer.prototype.remove === 'function');

  return isTypeSupported && sourceBufferValidAPI;
};

export const HLSCommon = {
  isHLSSupported,
};
